import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function withRouter(Component) {

  return function (props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const pageNumber = params.pageNumber || null;
    
    const history = {
      push: navigate,
      replace: (path, state) => navigate(path, { replace: true, state }),
      location,
    };

    const match = {
      params: { ...params, pageNumber },
      isExact: location.pathname === params['*'],
      path: "/",
      // location.pathname,
      url: location.pathname,
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={match}
      />
    );
  };
}

export default withRouter;